import { render, staticRenderFns } from "./WidgetSidebar.vue?vue&type=template&id=4c4245c4&"
import script from "./WidgetSidebar.vue?vue&type=script&lang=js&"
export * from "./WidgetSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports